var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiSelect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#91EAF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_18925)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.538 10.6262C11.2584 10.6262 11.0214 10.7241 10.8271 10.9199C10.6329 11.1156 10.5357 11.3533 10.5357 11.633C10.5357 11.9127 10.6336 12.1496 10.8294 12.3439C11.0251 12.5381 11.2628 12.6353 11.5425 12.6353C11.8222 12.6353 12.0591 12.5374 12.2534 12.3416C12.4477 12.1459 12.5448 11.9082 12.5448 11.6285C12.5448 11.3489 12.4469 11.1119 12.2511 10.9176C12.0554 10.7234 11.8177 10.6262 11.538 10.6262ZM11.538 19.6977C11.2584 19.6977 11.0214 19.7956 10.8271 19.9914C10.6329 20.1871 10.5357 20.4248 10.5357 20.7045C10.5357 20.9841 10.6336 21.2211 10.8294 21.4154C11.0251 21.6096 11.2628 21.7067 11.5425 21.7067C11.8222 21.7067 12.0591 21.6089 12.2534 21.4131C12.4477 21.2173 12.5448 20.9796 12.5448 20.7C12.5448 20.4203 12.4469 20.1834 12.2511 19.9891C12.0554 19.7948 11.8177 19.6977 11.538 19.6977ZM8.7276 8H23.2596C23.4787 8 23.6569 8.06842 23.7941 8.20525C23.9314 8.34206 24 8.52573 24 8.75624V14.3656C24 14.6329 23.9314 14.8514 23.7941 15.0213C23.6569 15.1911 23.4787 15.276 23.2596 15.276H8.7276C8.51704 15.276 8.34314 15.1911 8.20588 15.0213C8.06863 14.8514 8 14.6329 8 14.3656V8.75624C8 8.52573 8.06863 8.34206 8.20588 8.20525C8.34314 8.06842 8.51704 8 8.7276 8ZM9.06786 9.06786V14.2081H22.9321V9.06786H9.06786ZM8.7276 17.057H23.1638C23.387 17.057 23.5822 17.1472 23.7493 17.3277C23.9164 17.5082 24 17.7126 24 17.9409V23.428C24 23.7236 23.9164 23.9508 23.7493 24.1095C23.5822 24.2681 23.387 24.3475 23.1638 24.3475H8.83621C8.5973 24.3475 8.3982 24.2681 8.23892 24.1095C8.07964 23.9508 8 23.7236 8 23.428V17.9409C8 17.7126 8.06547 17.5082 8.1964 17.3277C8.32732 17.1472 8.50439 17.057 8.7276 17.057ZM9.06786 18.1249V23.2796H22.9321V18.1249H9.06786Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_18925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiSelect);
export default __webpack_public_path__ + "static/media/multiSelect.e2120b0abea1b41d04dd2a0fd9ae1b7a.svg";
export { ForwardRef as ReactComponent };